import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ApiService } from '@crowdctrl/shared';

type LeaseResponse = { acquired?: boolean; renewed?: boolean; released?: boolean };

@Injectable({
  providedIn: 'root',
})
export class OverviewLeaseService {
  private apiService = inject(ApiService);
  private baseUrl = '';

  setBaseUrl(url: string): void {
    this.baseUrl = url;
  }

  async acquireWorkspaceLease(workspaceId: string, holderId: string): Promise<boolean> {
    const res = await firstValueFrom(
      await this.apiService.post<LeaseResponse, { action: string; holderId: string }>(
        this.baseUrl,
        `/workspace_instances_api/api/workspace-instances/${workspaceId}/overview-lease`,
        { action: 'acquire', holderId },
      ),
    );
    return res?.acquired ?? false;
  }

  async renewWorkspaceLease(workspaceId: string, holderId: string): Promise<boolean> {
    const res = await firstValueFrom(
      await this.apiService.post<LeaseResponse, { action: string; holderId: string }>(
        this.baseUrl,
        `/workspace_instances_api/api/workspace-instances/${workspaceId}/overview-lease`,
        { action: 'renew', holderId },
      ),
    );
    return res?.renewed ?? false;
  }

  async releaseWorkspaceLease(workspaceId: string, holderId: string): Promise<void> {
    await firstValueFrom(
      await this.apiService.post<LeaseResponse, { action: string; holderId: string }>(
        this.baseUrl,
        `/workspace_instances_api/api/workspace-instances/${workspaceId}/overview-lease`,
        { action: 'release', holderId },
      ),
    );
  }

  async acquireSessionLease(
    workspaceId: string,
    sessionId: string,
    holderId: string,
  ): Promise<boolean> {
    const res = await firstValueFrom(
      await this.apiService.post<
        LeaseResponse,
        { action: string; holderId: string; workspaceId: string }
      >(
        this.baseUrl,
        `/workspace_sessions_api/api/workspace-sessions/${sessionId}/overview-lease`,
        { action: 'acquire', holderId, workspaceId },
      ),
    );
    return res?.acquired ?? false;
  }

  async renewSessionLease(
    workspaceId: string,
    sessionId: string,
    holderId: string,
  ): Promise<boolean> {
    const res = await firstValueFrom(
      await this.apiService.post<
        LeaseResponse,
        { action: string; holderId: string; workspaceId: string }
      >(
        this.baseUrl,
        `/workspace_sessions_api/api/workspace-sessions/${sessionId}/overview-lease`,
        { action: 'renew', holderId, workspaceId },
      ),
    );
    return res?.renewed ?? false;
  }

  async releaseSessionLease(
    workspaceId: string,
    sessionId: string,
    holderId: string,
  ): Promise<void> {
    await firstValueFrom(
      await this.apiService.post<
        LeaseResponse,
        { action: string; holderId: string; workspaceId: string }
      >(
        this.baseUrl,
        `/workspace_sessions_api/api/workspace-sessions/${sessionId}/overview-lease`,
        { action: 'release', holderId, workspaceId },
      ),
    );
  }
}
